import React from 'react';
import { useKatalFeatureFlag } from 'libs/hooks/useKatalFeatureFlag';
import WorkOrderTaskInfoCardAntD from './component-antd';
import WorkOrderTaskInfoCardKatal from './component-katal';
import type { WorkOrderTask } from '@xbcb/api-gateway-client';

interface WorkOrderTaskInfoCardProps {
  loading?: boolean;
  workOrderTask: WorkOrderTask;
}

const WorkOrderTaskInfoCard: React.FC<WorkOrderTaskInfoCardProps> = (props) => {
  const useKatal = useKatalFeatureFlag();

  return useKatal ? (
    <WorkOrderTaskInfoCardKatal {...props} />
  ) : (
    <WorkOrderTaskInfoCardAntD {...props} />
  );
};

export default WorkOrderTaskInfoCard;
